// extracted by mini-css-extract-plugin
export default {"button":"TnSnappboxLogoutButton_button__BPTtN"};